import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSpacingHeight01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 3a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM14.445 8.832 13 7.87v8.263l1.445-.964a1 1 0 1 1 1.11 1.664l-3 2a1 1 0 0 1-1.11 0l-3-2a1 1 0 0 1 1.11-1.664l1.445.964V7.869l-1.445.963a1 1 0 0 1-1.11-1.664l3-2a1 1 0 0 1 1.11 0l3 2a1 1 0 0 1-1.11 1.664Z"
    />
  </svg>
);
SvgSpacingHeight01.displayName = 'SpacingHeight01';
export default SvgSpacingHeight01;
